<template>
    <Card :title="$t('access.configurations.list')" containerClass="mb-5">
      <template #cardBody>
        <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_configfurations" style="margin-top: 13px !important; cursor:pointer">
          <thead style="background-color: #F2F3F4;">
            <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
                <th class="px-4 ">{{$t("access.configurations.access_method")}}</th>
                <th class="px-4 ">{{$t("access.configurations.pin_size")}}</th>
                <th class="px-4 ">{{$t("access.configurations.expired_time")}}</th>
                <th>{{$t("actions")}}</th>
            </tr> 
          </thead>
        </table>
      </template>
    </Card>

    <UpdateConfigurations :form="formEdit" @load="reloadDatatable" id="updateConfigurationModal" />
</template>

<script setup>
    import {ref,onMounted,watch,nextTick} from "vue";
    import {BASE_URL} from "@/services/api";
    import {useStore} from "vuex";
    import Ls from "@/services/ls";
    import { useI18n } from 'vue-i18n'
    import { useLocales } from '@/composables/locales';
    import UpdateConfigurations from "@/Modules/Access/components/Modals/Configurations/Update.vue";
    import Card from "@/Modules/CRM/components/Card";
    import {Theme} from "@/composables/theming";
    import {useSwal} from "@/composables/useSwal";
    import abilities from "@/composables/abilities";
    import {useHasAbility} from "@/composables/hasAbility";

    const table = ref(null)
    const formEdit = ref({
        id: '',
        access_method_id: '',
        access_name: '',
        expired_time: 0,
        pin_size: 0,
        default: false
    })
    const store = useStore()

    const { t } = useI18n({ useScope: 'global' })
    const {locale, datatableLocaleUrl} = useLocales()
    const {showSwal} = useSwal()
    const { can } = useHasAbility()

    function fetchDatas() {
        const AUTH_TOKEN = Ls.get('auth.token')

        table.value = $("#kt_datatable_configfurations").DataTable({
            destroy : true,
            responsive: !0,
            searchDelay: 500,
            processing: !0,
            serverSide: !0,
            pageLength:Ls.get('pageLength') ?? 5,
            lengthMenu: [5, 10, 25, 50, 75, 100 ],
            order: [[ 0, 'desc']],
            ajax: {
            url: BASE_URL+"/get/configuration/datatables",
            type: "GET",
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
                request.setRequestHeader("Company", Ls.get('current.company'));
                },
            data:  function ( d ) {

            }
            },
            columns: [{ data: "access_name" }, { data: "pin_size" }, { data: "expired_time" }, { data: "Actions", responsivePriority: -1 }],

            columnDefs: [
            {
                targets: -4,
                order: "desc",
                render: function (t, a, e, l) {
                return '<span class="nameRow'+ l.row +'">' + t + "</span>";
                },
            },
            {
                targets: -3,
                order: "desc",
                render: function (t, a, e, l) {
                return '<span class="pinRow'+ l.row +'">' + t + "</span>";
                },
            },
            {
                targets: -2,
                order: "desc",
                render: function (t, a, e, l) {
                return '<span class="timeRow'+ l.row +'">' + t + "</span>";
                },
            },
            {
                width: "5%",
                targets: -1,
                "className": "dt-center",
                title: "Actions",
                orderable: !1,
                render: (t, a, e, l) => {
                let render = '';
                if(true) render += `<a href="javascript:;" data-row="${l.row}" data-id="${e.id}" data-method="${e.access_method_id}" data-name="${e.access_name}" data-time="${e.expired_time}" data-pin="${e.pin_size}" data-default="${e.default}" class="btn btn-sm btn-clean btn-icon edit_btn" title="${i18n.global.t('button.edit')}"><i data-row="${l.row}" data-id="${e.id}" data-method="${e.access_method_id}" data-name="${e.access_name}" data-time="${e.expired_time}" data-pin="${e.pin_size}" data-default="${e.default}" class="fas fa-edit fs-2"  style="color: ${Theme.gray}" style="color: ${Theme.gray}"></i></a>`;
                return render;
                },
            },

            ],
            language: {
            url:  datatableLocaleUrl.value
            }
        });

        $(document).on("click", "#kt_datatable_configfurations .edit_btn", (e) => {
            formEdit.value.id = e.target.getAttribute('data-id')
            formEdit.value.access_method_id = e.target.getAttribute('data-method')
            formEdit.value.access_name = e.target.getAttribute('data-name')
            formEdit.value.expired_time = e.target.getAttribute('data-time')
            formEdit.value.pin_size = e.target.getAttribute('data-pin')
            formEdit.value.default = e.target.getAttribute('data-default')
            
            $('#updateConfigurationModal').modal('toggle')
        });
    }

    function reloadDatatable(){
        table.value.ajax.reload()
    }

    watch(() => locale.value, () => {
        nextTick(()=> fetchDatas())
    })

    onMounted(() => {
        fetchDatas()
    })
</script>